'use client';

import { Avatar, Box, Divider, SystemIcon } from '@wishket/design-system';

import { LinkButton, LoginMenu, MobileLinkButton } from './parts';

import { Profile } from '@/shared/types';
import { PATH } from '@/shared/constants';

interface UserMenuBoxProps {
  isAuth: boolean;
  nextPath: string;
  profile?: Profile;
  openSearch: () => void;
  openUserMenu: () => void;
}

const UserMenuBox = ({
  isAuth,
  nextPath,
  profile,
  openSearch,
  openUserMenu,
}: UserMenuBoxProps) => {
  return (
    <Box
      data-testid="user-menu-box"
      className="flex items-center justify-between gap-4"
    >
      <Box className="flex items-center gap-4 desktop:gap-1">
        <MobileLinkButton
          href={PATH.YOZM_ADVERTISEMENT}
          name="광고 상품"
          isNewWindow
        />

        <button
          onClick={openSearch}
          className="desktop:mr-2.5"
          aria-label="Search Icon"
        >
          <SystemIcon name="large_search" className="text-w-gray-900" />
        </button>

        <Box className="hidden items-center gap-1 desktop:flex">
          <Divider isVertical className="h-3.5" />
          <LinkButton
            href={PATH.YOZM_ADVERTISEMENT}
            name="광고 상품"
            isNewWindow
          />
          <LinkButton
            href={PATH.YOZM_AUTHOR_APPLY}
            name="작가 지원"
            isNewWindow
          />
          <Divider isVertical className="h-3.5" />
        </Box>

        <Box className="hidden desktop:block">
          {isAuth ? (
            <Box
              className="ml-2.5 cursor-pointer"
              data-testid="user-menu-box-profile"
            >
              <Avatar imgUrl={profile?.imgSrc} onClick={openUserMenu} />
            </Box>
          ) : (
            <LoginMenu nextPath={nextPath} />
          )}
        </Box>

        <button className="desktop:hidden" onClick={openUserMenu}>
          <SystemIcon name="large_drawer" />
        </button>
      </Box>
    </Box>
  );
};

export default UserMenuBox;
